import { render } from "./CollaboratorFilters.vue?vue&type=template&id=c2dc966e&scoped=true"
import script from "./CollaboratorFilters.vue?vue&type=script&lang=js"
export * from "./CollaboratorFilters.vue?vue&type=script&lang=js"

import "./CollaboratorFilters.vue?vue&type=style&index=0&id=c2dc966e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2dc966e"]])

export default __exports__